import React, { useEffect, useMemo, useState } from "react";
import MentorCard from "../MentorCard";
import { CrookedStar, FourPointStar, MentorAndre, MentorAisha, MentorFarah, MentorIrene, MentorMuthia, MentorNazneen, MentorPuti } from "../../../assets";

const mentorCards = [
	{
		image: MentorAndre,
		badge: "Senior Instructor",
		name: "Mr. Andre Wicaksono",
		title: "IELTS SPEAKING & LISTENING COACH",
		bio: "Membantu siswa membangun kepercayaan diri saat speaking dan listening lewat latihan yang terarah, realistis, dan penuh feedback.",
		ieltsScore: "8.0",
		students: "180+",
		imageZoom: 1,
		imageZoomTablet: 1.2,
		imageZoomMobile: 1.15,
		imagePositionX: "center",
		imagePositionXTablet: "center",
		imagePositionXMobile: "center",
		imagePositionY: "70%",
		imagePositionYTablet: "70%",
		imagePositionYMobile: "70%",
		skills: [
			{ label: "SPEAKING", bgClass: "bg-[#d8f3e8]", textClass: "text-[#138f68]" },
			{ label: "LISTENING", bgClass: "bg-[#dde8ff]", textClass: "text-[#325bdb]" },
			{ label: "PRONUNCIATION", bgClass: "bg-[#efe0ff]", textClass: "text-[#7a3ee0]" },
		],
	},
	{
		image: MentorPuti,
		badge: "Instructor",
		name: "Ms. Puti Tanjung Intan",
		title: "READING & VOCABULARY EXPERT",
		bio: "Fokus membantu siswa memahami text, memperkaya kosakata, dan mengerjakan reading dengan strategi yang lebih efisien.",
		ieltsScore: "8.0",
		students: "150+",
		imageZoom: 1.12,
		imageZoomTablet: 1.14,
		imageZoomMobile: 1.1,
		imagePositionX: "center",
		imagePositionXTablet: "center",
		imagePositionXMobile: "center",
		imagePositionY: "85%",
		imagePositionYTablet: "85%",
		imagePositionYMobile: "95%",
		skills: [
			{ label: "READING", bgClass: "bg-[#d8f3e8]", textClass: "text-[#138f68]" },
			{ label: "VOCABULARY", bgClass: "bg-[#dde8ff]", textClass: "text-[#325bdb]" },
			{ label: "LPDP PREP", bgClass: "bg-[#efe0ff]", textClass: "text-[#7a3ee0]" },
		],
	},
	{
		image: MentorAisha,
		badge: "Instructor",
		name: "Ms. Aisha Naudira",
		title: "IELTS PREPARATION MENTOR",
		bio: "Membimbing siswa membangun fondasi belajar yang rapi, terarah, dan lebih percaya diri untuk persiapan IELTS.",
		ieltsScore: "8.0",
		students: "130+",
		imageZoom: 1.14,
		imageZoomTablet: 1.16,
		imageZoomMobile: 1.12,
		imagePositionX: "center",
		imagePositionXTablet: "center",
		imagePositionXMobile: "center",
		imagePositionY: "60%",
		imagePositionYTablet: "60%",
		imagePositionYMobile: "70%",
		skills: [
			{ label: "READING", bgClass: "bg-[#d8f3e8]", textClass: "text-[#138f68]" },
			{ label: "VOCABULARY", bgClass: "bg-[#dde8ff]", textClass: "text-[#325bdb]" },
			{ label: "WRITING", bgClass: "bg-[#efe0ff]", textClass: "text-[#7a3ee0]" },
		],
	},
	{
		image: MentorFarah,
		badge: "Instructor",
		name: "Ms. Farah Indy",
		title: "IELTS SPEAKING MENTOR",
		bio: "Membantu siswa memperkuat kemampuan speaking dengan latihan yang lebih natural, fokus, dan terarah.",
		ieltsScore: "8.0",
		students: "145+",
		imageZoom: 1.16,
		imageZoomTablet: 1.18,
		imageZoomMobile: 1.12,
		imagePositionX: "center",
		imagePositionXTablet: "center",
		imagePositionXMobile: "center",
		imagePositionY: "42%",
		imagePositionYTablet: "40%",
		imagePositionYMobile: "44%",
		skills: [
			{ label: "SPEAKING", bgClass: "bg-[#d8f3e8]", textClass: "text-[#138f68]" },
			{ label: "PRONUNCIATION", bgClass: "bg-[#dde8ff]", textClass: "text-[#325bdb]" },
			{ label: "FLUENCY", bgClass: "bg-[#efe0ff]", textClass: "text-[#7a3ee0]" },
		],
	},
	{
		image: MentorIrene,
		badge: "Instructor",
		name: "Ms. Irene G",
		title: "IELTS LISTENING MENTOR",
		bio: "Mendampingi siswa memahami audio dengan lebih tenang, akurat, dan strategis melalui latihan rutin.",
		ieltsScore: "8.0",
		students: "125+",
		imageZoom: 1.12,
		imageZoomTablet: 1.14,
		imageZoomMobile: 1.1,
		imagePositionX: "center",
		imagePositionXTablet: "center",
		imagePositionXMobile: "center",
		imagePositionY: "70%",
		imagePositionYTablet: "75%",
		imagePositionYMobile: "75%",
		skills: [
			{ label: "LISTENING", bgClass: "bg-[#d8f3e8]", textClass: "text-[#138f68]" },
			{ label: "NOTE TAKING", bgClass: "bg-[#dde8ff]", textClass: "text-[#325bdb]" },
			{ label: "CONCENTRATION", bgClass: "bg-[#efe0ff]", textClass: "text-[#7a3ee0]" },
		],
	},
	{
		image: MentorMuthia,
		badge: "Instructor",
		name: "Ms. Muthia Mahira",
		title: "IELTS WRITING MENTOR",
		bio: "Membantu siswa menulis dengan struktur yang lebih kuat, jelas, dan sesuai kebutuhan band score IELTS.",
		ieltsScore: "8.0",
		students: "110+",
		imageZoom: 1.16,
		imageZoomTablet: 1.18,
		imageZoomMobile: 1.12,
		imagePositionX: "center",
		imagePositionXTablet: "center",
		imagePositionXMobile: "center",
		imagePositionY: "60%",
		imagePositionYTablet: "65%",
		imagePositionYMobile: "65%",
		skills: [
			{ label: "WRITING", bgClass: "bg-[#d8f3e8]", textClass: "text-[#138f68]" },
			{ label: "GRAMMAR", bgClass: "bg-[#dde8ff]", textClass: "text-[#325bdb]" },
			{ label: "TASK RESPONSE", bgClass: "bg-[#efe0ff]", textClass: "text-[#7a3ee0]" },
		],
	},
	{
		image: MentorNazneen,
		badge: "Instructor",
		name: "Ms. Shazia D Nazneen",
		title: "IELTS STRATEGY MENTOR",
		bio: "Fokus membantu siswa menyusun strategi belajar yang efisien, realistis, dan konsisten sampai ujian.",
		ieltsScore: "8.0",
		students: "115+",
		imageZoom: 1.14,
		imageZoomTablet: 1.16,
		imageZoomMobile: 1.1,
		imagePositionX: "10px",
		imagePositionXTablet: "center",
		imagePositionXMobile: "center",
		imagePositionY: "80%",
		imagePositionYTablet: "95%",
		imagePositionYMobile: "95%",
		skills: [
			{ label: "STRATEGY", bgClass: "bg-[#d8f3e8]", textClass: "text-[#138f68]" },
			{ label: "PLANNING", bgClass: "bg-[#dde8ff]", textClass: "text-[#325bdb]" },
			{ label: "CONSISTENCY", bgClass: "bg-[#efe0ff]", textClass: "text-[#7a3ee0]" },
		],
	},
];

const getSlideSize = () => {
	if (typeof window === "undefined") {
		return 3;
	}

	if (window.innerWidth >= 1024) {
		return 3;
	}

	if (window.innerWidth >= 640) {
		return 2;
	}

	return 1;
};

const chunkMentors = (items, size) => {
	const slides = [];

	for (let index = 0; index < items.length; index += size) {
		slides.push(items.slice(index, index + size));
	}

	return slides;
};

const ChevronLeft = () => (
	<svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 sm:h-6 sm:w-6">
		<path d="M14.5 6.5 9 12l5.5 5.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" />
	</svg>
);

const ChevronRight = () => (
	<svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 sm:h-6 sm:w-6">
		<path d="m9.5 6.5 5.5 5.5-5.5 5.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" />
	</svg>
);

const Mentors = () => {
	const [slideSize, setSlideSize] = useState(getSlideSize);
	const mentorSlides = useMemo(() => chunkMentors(mentorCards, slideSize), [slideSize]);
	const [activeSlide, setActiveSlide] = useState(0);
	const [isHoverPaused, setIsHoverPaused] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setSlideSize(getSlideSize());
		};

		handleResize();
		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		setActiveSlide((currentSlide) => Math.min(currentSlide, Math.max(mentorSlides.length - 1, 0)));
	}, [mentorSlides.length]);

	useEffect(() => {
		if (mentorSlides.length <= 1 || isHoverPaused) {
			return undefined;
		}

		const intervalId = window.setInterval(() => {
			setActiveSlide((currentSlide) => (currentSlide + 1) % mentorSlides.length);
		}, 5000);

		return () => window.clearInterval(intervalId);
	}, [isHoverPaused, mentorSlides.length]);

	const goToSlide = (nextIndex) => {
		const normalizedIndex = (nextIndex + mentorSlides.length) % mentorSlides.length;
		setActiveSlide(normalizedIndex);
	};

	const prevSlide = () => goToSlide(activeSlide - 1);
	const nextSlide = () => goToSlide(activeSlide + 1);

	return (
		<section className="st-aboutus-mentor overflow-hidden px-4 py-14 sm:py-16 lg:py-20">
			<div className="relative mx-auto w-full max-w-7xl">
				<img
					src={FourPointStar}
					alt=""
					aria-hidden="true"
					loading="lazy"
					className="pointer-events-none absolute right-[-5rem] top-[-1.5rem] hidden w-[18rem] md:block lg:top-[-4rem] lg:right-[-20rem] lg:w-[28rem]"
				/>
				<img
					src={CrookedStar}
					alt=""
					aria-hidden="true"
					loading="lazy"
					className="pointer-events-none absolute bottom-[-3rem] left-[-5.5rem] hidden w-[24rem] md:block lg:top-[36rem] lg:left-[-28rem] lg:w-[32rem]"
				/>

				<div className="relative z-10 text-center">
					<h2 className="st-aboutus-mentor-title st-font-display text-[42px] leading-[0.95] tracking-[-0.04em] sm:text-[56px] md:text-[66px] lg:text-[74px]">
						<span className="italic">Meet Our</span> Mentors!
					</h2>
					<p className="st-aboutus-mentor-subtitle st-font-body mx-auto mt-5 max-w-[760px] text-[14px] leading-[1.55] text-[#4f463d] sm:mt-6 sm:text-[18px] lg:text-[18px]">
						Setiap tutor Scholars Today adalah alumni universitas luar negeri yang telah melewati seleksi beasiswa dan IELTS secara nyata. Mereka mengajar bukan hanya dari buku, tapi dari pengalaman yang sudah mereka buktikan sendiri.
					</p>
				</div>

				<div
					className="relative mt-10 sm:mt-12 lg:mt-14"
					onMouseEnter={() => setIsHoverPaused(true)}
					onMouseLeave={() => setIsHoverPaused(false)}
				>
					<button
						type="button"
						onClick={prevSlide}
						aria-label="Previous mentor"
						className="st-aboutus-mentor-arrow absolute left-[-1.5rem] top-1/2 z-20 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full sm:h-12 sm:w-12 sm:left-[-24px] lg:left-[-1.5rem]"
					>
						<ChevronLeft />
					</button>

					<button
						type="button"
						onClick={nextSlide}
						aria-label="Next mentor"
						className="st-aboutus-mentor-arrow absolute right-[-1.5rem] top-1/2 z-20 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full sm:h-12 sm:w-12 sm:right-[-24px] lg:right-[-1.5rem]"
					>
						<ChevronRight />
					</button>

					<div className="overflow-hidden px-1 pt-2">
						<div
							className="st-aboutus-mentor-track flex transition-transform duration-500 ease-out"
							style={{ transform: `translateX(-${activeSlide * 100}%)` }}
						>
							{mentorSlides.map((slide, slideIndex) => (
								<div key={`mentor-slide-${slideIndex}`} className="w-full flex-none px-0">
									<div className="grid gap-5 sm:gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-7">
										{slide.map((mentor) => (
											<div key={mentor.name} className="min-w-0">
												<MentorCard mentor={mentor} />
											</div>
										))}
									</div>
								</div>
							))}
						</div>
					</div>
				</div>

				<div className="mt-5 flex items-center justify-center gap-2.5 sm:mt-6">
					{mentorSlides.map((slide, index) => (
						<button
							key={`mentor-dot-${slide[0]?.name || index}`}
							type="button"
							onClick={() => goToSlide(index)}
							aria-label={`Go to mentor ${index + 1}`}
							className={`h-3 rounded-full transition-all duration-200 ${
								activeSlide === index ? "st-aboutus-mentor-dot-active w-10 sm:w-11" : "st-aboutus-mentor-dot w-3"
							}`}
						/>
					))}
				</div>
			</div>
		</section>
	);
};

export default Mentors;
